module.exports = __webpack_public_path__ + "img/three1Orange.46a05ae7.jpg";